import l from"./a-callable.js";import n from"./is-null-or-undefined.js";var d=l,f=n,i=function(r,a){var e=r[a];return f(e)?void 0:d(e)};export{i as default};
